'use client';

import { AppImageData } from '@components/appImage';
import { CasesSlider as LegacyCasesSlider } from '@components/casesSlider';
import { CaseSliderCard } from '@components/casesSlider';

import { CaseCardMobile } from './CaseCardMobile';
import { CaseCardWeb } from './CaseCardWeb';

interface CasesSliderProps {
  title: string;
  link: string;
  articlesCards: CaseSliderCard[];
  allCasesCardText: string;
  allCasesButtonText?: string;
  allCasesBgData: AppImageData;
  halfPageSliderOverlayUrl: string;
  withoutAllCasesCard?: boolean;
}

export const CasesSlider = (props: CasesSliderProps) => {
  return (
    <>
      <LegacyCasesSlider
        {...props}
        allCasesButtonTarget="_blank"
        slideHeight="510px"
        renderWebCard={(card) => <CaseCardWeb card={card} />}
        renderMobileCard={(card) => <CaseCardMobile card={card} />}
      />
    </>
  );
};
